// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportingType.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.ReportingTypeAction');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  var CONSTANTS = require('logic/data/Izenda.SchedulingSearchConstants');
  const { remove } = require('lodash/fp');

  var ReportingType = function(props) {
    var criteria = props.criteria;
    var localization = props.localization;
    var hasDashboardLicense = props.authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Dashboard);
    var reportTypeOption = remove(function(type) {
      return !hasDashboardLicense && type.value === 'Dashboard';
    }, CONSTANTS.REPORT_TYPE);

    return (
      <GridLayout.Row className="u_marginBottom">
        <GridLayout.Col cols={1} className="u_textRight">
          <label className="control-label">{localization.getText('SYSTEM_CONFIGURATION_LABEL_REPORTING_TYPE')}</label>
        </GridLayout.Col>
        <GridLayout.Col cols={11} className="izenda-SearchCriteria_ReportType">
          <DropDown
            className="u_floatLeft"
            value={criteria.reportType}
            options={reportTypeOption}
            onChange={props.handleChangeReportType}
          />
          <Select
            className="u_floatLeft"
            placeholder={localization.getText('SYSTEM_CONFIGURATION_PLACEHOLDER_REPORT_OR_DASHBOARD_NAME')}
            value={criteria.name}
            multi={true}
            delimiter=";"
            simpleValue={true}
            joinValues={true}
            onAddNew={props.onAddNewReportName}
            options={criteria.reportDashboardNameOptions}
            onBlur={props.handleBlur}
            onChange={props.handleChangeReportName}
            onInputChange={props.handleInputChange}
            onBlurResetsInput={false}
            isInsertOnBlur
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  module.exports = connect(action)(ReportingType);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.ReportingType.jsx